module.exports = __webpack_public_path__ + "img/plus.dc8e72e1.png";